var z = Object.defineProperty;
var R = (t) => {
  throw TypeError(t);
};
var U = (t, e, n) => e in t ? z(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var p = (t, e, n) => U(t, typeof e != "symbol" ? e + "" : e, n), H = (t, e, n) => e.has(t) || R("Cannot " + n);
var F = (t, e, n) => e.has(t) ? R("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n);
var h = (t, e, n) => (H(t, e, "access private method"), n);
import { uid as J } from "uid";
var b = function() {
  var t = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (t && t.responseStart > 0 && t.responseStart < performance.now()) return t;
}, K = function(t) {
  var e = t.nodeName;
  return t.nodeType === 1 ? e.toLowerCase() : e.toUpperCase().replace(/^#/, "");
}, Y = function(t, e) {
  var n = "";
  try {
    for (; t && t.nodeType !== 9; ) {
      var i = t, r = i.id ? "#" + i.id : K(i) + (i.classList && i.classList.value && i.classList.value.trim() && i.classList.value.trim().length ? "." + i.classList.value.trim().replace(/\s+/g, ".") : "");
      if (n.length + r.length > (e || 100) - 1) return n || r;
      if (n = n ? r + ">" + n : r, i.id) break;
      t = i.parentNode;
    }
  } catch {
  }
  return n;
}, A = -1, G = function() {
  return A;
}, M = function(t) {
  addEventListener("pageshow", function(e) {
    e.persisted && (A = e.timeStamp, t(e));
  }, !0);
}, D = function() {
  var t = b();
  return t && t.activationStart || 0;
}, g = function(t, e) {
  var n = b(), i = "navigate";
  return G() >= 0 ? i = "back-forward-cache" : n && (document.prerendering || D() > 0 ? i = "prerender" : document.wasDiscarded ? i = "restore" : n.type && (i = n.type.replace(/_/g, "-"))), { name: t, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: i };
}, W = function(t, e, n) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(t)) {
      var i = new PerformanceObserver(function(r) {
        Promise.resolve().then(function() {
          e(r.getEntries());
        });
      });
      return i.observe(Object.assign({ type: t, buffered: !0 }, n || {})), i;
    }
  } catch {
  }
}, v = function(t, e, n, i) {
  var r, a;
  return function(o) {
    e.value >= 0 && (o || i) && ((a = e.value - (r || 0)) || r === void 0) && (r = e.value, e.delta = a, e.rating = function(c, u) {
      return c > u[1] ? "poor" : c > u[0] ? "needs-improvement" : "good";
    }(e.value, n), t(e));
  };
}, X = function(t) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return t();
    });
  });
}, B = function(t) {
  document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && t();
  });
}, C = function(t) {
  var e = !1;
  return function() {
    e || (t(), e = !0);
  };
}, m = -1, _ = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, y = function(t) {
  document.visibilityState === "hidden" && m > -1 && (m = t.type === "visibilitychange" ? t.timeStamp : 0, Z());
}, I = function() {
  addEventListener("visibilitychange", y, !0), addEventListener("prerenderingchange", y, !0);
}, Z = function() {
  removeEventListener("visibilitychange", y, !0), removeEventListener("prerenderingchange", y, !0);
}, $ = function() {
  return m < 0 && (m = _(), I(), M(function() {
    setTimeout(function() {
      m = _(), I();
    }, 0);
  })), { get firstHiddenTime() {
    return m;
  } };
}, P = function(t) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return t();
  }, !0) : t();
}, ee = function(t) {
  var e = self.requestIdleCallback || self.setTimeout, n = -1;
  return t = C(t), document.visibilityState === "hidden" ? t() : (n = e(t), B(t)), n;
}, k = [2500, 4e3], w = {}, te = function(t, e) {
  (function(n, i) {
    i = i || {}, P(function() {
      var r, a = $(), o = g("LCP"), c = function(d) {
        i.reportAllChanges || (d = d.slice(-1)), d.forEach(function(f) {
          f.startTime < a.firstHiddenTime && (o.value = Math.max(f.startTime - D(), 0), o.entries = [f], r());
        });
      }, u = W("largest-contentful-paint", c);
      if (u) {
        r = v(n, o, k, i.reportAllChanges);
        var l = C(function() {
          w[o.id] || (c(u.takeRecords()), u.disconnect(), w[o.id] = !0, r(!0));
        });
        ["keydown", "click"].forEach(function(d) {
          addEventListener(d, function() {
            return ee(l);
          }, !0);
        }), B(l), M(function(d) {
          o = g("LCP"), r = v(n, o, k, i.reportAllChanges), X(function() {
            o.value = performance.now() - d.timeStamp, w[o.id] = !0, r(!0);
          });
        });
      }
    });
  })(function(n) {
    var i = function(r) {
      var a = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadDuration: 0, elementRenderDelay: r.value };
      if (r.entries.length) {
        var o = b();
        if (o) {
          var c = o.activationStart || 0, u = r.entries[r.entries.length - 1], l = u.url && performance.getEntriesByType("resource").filter(function(Q) {
            return Q.name === u.url;
          })[0], d = Math.max(0, o.responseStart - c), f = Math.max(d, l ? (l.requestStart || l.startTime) - c : 0), T = Math.max(f, l ? l.responseEnd - c : 0), j = Math.max(T, u.startTime - c);
          a = { element: Y(u.element), timeToFirstByte: d, resourceLoadDelay: f - d, resourceLoadDuration: T - f, elementRenderDelay: j - T, navigationEntry: o, lcpEntry: u }, u.url && (a.url = u.url), l && (a.lcpResourceEntry = l);
        }
      }
      return Object.assign(r, { attribution: a });
    }(n);
    t(i);
  }, e);
}, x = [800, 1800], ne = function t(e) {
  document.prerendering ? P(function() {
    return t(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return t(e);
  }, !0) : setTimeout(e, 0);
}, ie = function(t, e) {
  e = e || {};
  var n = g("TTFB"), i = v(t, n, x, e.reportAllChanges);
  ne(function() {
    var r = b();
    r && (n.value = Math.max(r.responseStart - D(), 0), n.entries = [r], i(!0), M(function() {
      n = g("TTFB", 0), (i = v(t, n, x, e.reportAllChanges))(!0);
    }));
  });
}, re = function(t, e) {
  ie(function(n) {
    var i = function(r) {
      var a = { waitingDuration: 0, cacheDuration: 0, dnsDuration: 0, connectionDuration: 0, requestDuration: 0 };
      if (r.entries.length) {
        var o = r.entries[0], c = o.activationStart || 0, u = Math.max((o.workerStart || o.fetchStart) - c, 0), l = Math.max(o.domainLookupStart - c, 0), d = Math.max(o.connectStart - c, 0), f = Math.max(o.connectEnd - c, 0);
        a = { waitingDuration: u, cacheDuration: l - u, dnsDuration: d - l, connectionDuration: f - d, requestDuration: r.value - f, navigationEntry: o };
      }
      return Object.assign(r, { attribution: a });
    }(n);
    t(i);
  }, e);
}, s, E, q, O, V, S, L, N;
class se {
  constructor(e) {
    F(this, s);
    p(this, "resourceMonitoringResultsToSend");
    p(this, "timeoutId");
    p(this, "requestThrottleMs");
    p(this, "sending");
    p(this, "sentResults");
    p(this, "webVitalsQueue");
    p(this, "resourcesEndpoint");
    p(this, "webVitalsEndpoint");
    this.appId = e.appId, this.enabledFeatures = (e == null ? void 0 : e.enabledFeatures) || {}, this.domainName = (e == null ? void 0 : e.domainName) || window.location.hostname, this.webVitalsQueue = /* @__PURE__ */ new Set(), this.resourcesEndpoint = "/resources/add", this.webVitalsEndpoint = "/web-vitals/add", this._apiEndpoint = "https://api.perforgo.com/api/app/" + this.appId + "/analytics", this.resourceMonitoringResultsToSend = [], this.timeoutId = null, this.requestThrottleMs = 3e3, this.sending = !1, this.sentResults = [];
  }
  init() {
    if (!this.appId) {
      console.error(
        "You need to specify a Perforgo App ID. Analytics reporting is disabled."
      );
      return;
    }
    if (this.enabledFeatures.lcp && te(
      (e) => {
        var n, i;
        return h(this, s, L).call(this, e, {
          hostname: (n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname,
          page_path: (i = window == null ? void 0 : window.location) == null ? void 0 : i.pathname
        });
      }
    ), this.enabledFeatures.fcp, this.enabledFeatures.fid, this.enabledFeatures.ttfb && re(
      (e) => {
        var n, i;
        return h(this, s, L).call(this, e, {
          hostname: (n = window == null ? void 0 : window.location) == null ? void 0 : n.hostname,
          page_path: (i = window == null ? void 0 : window.location) == null ? void 0 : i.pathname
        });
      }
    ), this.enabledFeatures.resourceMonitoring) {
      const e = new PerformanceObserver((i) => {
        i.getEntries().forEach((r) => {
          if (r.entryType === "resource") {
            const a = r;
            h(this, s, S).call(this, a);
          }
        });
      });
      e.observe({ type: "resource", buffered: !0 }), e.takeRecords().forEach((i) => {
        if (i.entryType === "resource") {
          const r = i;
          h(this, s, S).call(this, r);
        }
      }), this.timeoutId = setTimeout(
        async () => await h(this, s, E).call(this, this.resourceMonitoringResultsToSend),
        this.requestThrottleMs
      );
    }
    addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && h(this, s, N).call(this);
    });
  }
  get apiEndpoint() {
    return this._apiEndpoint;
  }
}
s = new WeakSet(), E = async function(e) {
  let n = [], i = null;
  if (e.length && (n = e.filter((r) => !(this.sentResults.findIndex(
    (a) => a.perforgo_resource_id === r.perforgo_resource_id
  ) >= 0)), !!n.length && (i = JSON.stringify(n), !this.sending))) {
    this.sending = !0;
    try {
      await fetch(this.apiEndpoint + this.resourcesEndpoint, {
        body: i,
        method: "POST",
        keepalive: !0,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }), this.sentResults.push(...n), this.sending = !1;
    } catch (r) {
      console.log(r);
    }
  }
}, q = function() {
  this.timeoutId && clearTimeout(this.timeoutId), this.timeoutId = setTimeout(
    async () => await h(this, s, E).call(this, this.resourceMonitoringResultsToSend),
    this.requestThrottleMs
  );
}, O = function(e) {
  return e;
}, V = function(e) {
  var n, i, r;
  return (i = (n = this.enabledFeatures.resourceMonitoring) == null ? void 0 : n.excludedDomains) != null && i.length ? ((r = this.enabledFeatures.resourceMonitoring) == null ? void 0 : r.excludedDomains.filter(
    (a) => a.matchType === "includes" ? !e.includes(a.domainName) : a.domainName !== e
  ).length) > 0 : !0;
}, S = function(e) {
  var n, i;
  h(this, s, q).call(this), !(e.transferSize === 0 && e.decodedBodySize > 0) && (i = (n = this.enabledFeatures) == null ? void 0 : n.resourceMonitoring) != null && i.images && e.initiatorType === "img" && h(this, s, V).call(this, new URL(e.name).hostname) && this.resourceMonitoringResultsToSend.push({
    perforgo_resource_id: J(),
    resource_domain: new URL(e.name).hostname,
    resource_path: new URL(e.name).pathname,
    hostname: this.domainName,
    type: e.initiatorType,
    transfer_size: h(this, s, O).call(this, e.transferSize),
    page_path: window.location.pathname
  });
}, L = function(e, n) {
  this.webVitalsQueue.add({
    ...e,
    ...n
  });
}, N = function() {
  if (this.webVitalsQueue.size > 0) {
    const e = JSON.stringify([...this.webVitalsQueue]);
    navigator.sendBeacon && navigator.sendBeacon(
      this.apiEndpoint + this.webVitalsEndpoint,
      new Blob([e], { type: "application/json" })
    ) || fetch(this.apiEndpoint + this.webVitalsEndpoint, {
      body: e,
      method: "POST",
      keepalive: !0,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    }), this.webVitalsQueue.clear();
  }
};
export {
  se as Perforgo
};
